<div id="sidebar-container" class="mt-2 d-none d-md-block sidebar-expanded">
  <ul class="list-group" id="accordion">

    <li *ngFor="let item of menuList.accessControl; let i = index">
      <a [ngClass]="{ 'active': selectedMenuItem == item.menu.name }" (click)="listItemClick(item.menu.name, i)"
        [id]="item.menu.name" [name]="item.menu.name" [attr.data-target]="'#submenu_' + item.menu.id"
        data-toggle="collapse" aria-expanded="true"
        class="flex-column align-items-start collapsed menu-link menu-link-one"
        style="padding: 0.5rem 1rem; border-right: 0px;">
        <div class="d-flex w-100 justify-content-start align-items-center" (click)="onDocumentMenuClick(item.menu)">
          <span class="fa fa-fw mr-3 bg-theme-icon" [ngClass]="getIconClass(item.menu.name)"></span>

          <span class="menu-collapsed" style="font-size: 14px;">
            {{ item.menu.displayName }}
          </span>

          <span *ngIf="
              item.menu.name != 'Document Management' &&
              item.menu.name != 'HR Reports' &&
              item.menu.name != 'Account Reports' &&
              item.menu.name != 'Reports' &&
              item.menu.name != 'Dashboard' &&
              item.menu.name != 'Announcements' &&
              item.menu.name != 'Master Data' &&
              item.menu.name != 'Standard Reports' &&
              item.menu.name != 'User Details' &&
              item.menu.name != 'Managing Partner'
            " [ngClass]="
              arrowDownIndex.includes(i)
                ? 'submenu-icon ml-auto fa fa-chevron-down'
                : 'submenu-icon ml-auto fa fa-chevron-right'
            "></span>
        </div>
      </a>

      <!-- SUBMENUS -->
      <div id="submenu_{{ item.menu.id }}" class="sidebar-submenu collapse">
        <!-- 1️⃣ Normal Submenus -->
        <ng-container *ngFor="let submenu of item.menu.submenus">
          <a [ngClass]="{ 'submenuActive': selectedSubmenuItem == submenu.subMenu }"
            (click)="onChangeMenuClick(submenu, item.menu)" class="menu-link">
    <li>
      <span class="menu-collapsed" style="font-size: 12px; padding: 5px;">
        <span class="fa fa-fw mr-2 bg-theme-icon" style="padding-left: 25px;"
          [ngClass]="getIconClass(submenu.subMenu)"></span>

        <span style="padding-left: 15px;">
          {{ submenu.subMenu }}
        </span>
      </span>
    </li>
    </a>
    </ng-container>

    <!-- 2️⃣ menuComponents should also act as submenus -->
    <!-- <ng-container *ngFor="let comp of item.menu.menuComponents">
          <a
            [ngClass]="{ 'submenuActive': selectedSubmenuItem == comp.name }"
            (click)="onChangeMenuClick(comp, item.menu)"
            class="menu-link"
          >
            <li>
              <span class="menu-collapsed" style="font-size: 12px; padding: 5px;">
                <span
                  class="fa fa-fw mr-2 bg-theme-icon"
                  style="padding-left: 25px;"
                  [ngClass]="getIconClass(comp.name)"
                ></span>

                <span style="padding-left: 15px;">
                  {{ comp.name }}
                </span>
              </span>
            </li>
          </a>
        </ng-container> -->

</div>
</li>
</ul>
</div>